<template>
  <div class="wysiwyg">
    <p v-for="(paragraph, index) in aftercareDescription" :key="index">
      {{ paragraph }}
    </p>
  </div>

  <ul v-if="aftercareItems.length > 0" class="aftercare__list">
    <li v-for="item in aftercareItems" :key="item">
      {{ item }}
    </li>
  </ul>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "Aftercare",
  computed: {
    ...mapState("product", ["product"]),
    aftercareDescription() {
      if (!this.product.aftercareDescription) return [];
      const str = this.product.aftercareDescription.value;
      const paragraphs = str.split(/\r?\n/);
      return paragraphs;
    },
    aftercareItems() {
      const aftercareBooleans = {
        dryCleanOnly: this.product.dryCleanOnly?.value === "true",
        doNotBleach: this.product.doNotBleach?.value === "true",
        doNotDryClean: this.product.doNotDryClean?.value === "true",
        handWashAt30Degrees: this.product.handWashAt30Degrees?.value === "true",
        handWashInColdWater: this.product.handWashInColdWater?.value === "true",
        washAt30Degrees: this.product.washAt30Degrees?.value === "true",
        ironAtLowTemperature:
          this.product.ironAtLowTemperature?.value === "true",
        doNotTumbleDry: this.product.doNotTumbleDry?.value === "true",
        doNotIron: this.product.doNotIron?.value === "true",
        doNotSteam: this.product.doNotSteam?.value === "true",
        doNotIronOrSteam: this.product.doNotIronOrSteam?.value === "true",
      };

      const labels = {
        dryCleanOnly: "Dry clean only",
        doNotBleach: "Do not bleach",
        doNotDryClean: "Do not dry clean",
        handWashAt30Degrees: "Hand wash at 30 degrees",
        handWashInColdWater: "Hand wash in cold water",
        washAt30Degrees: "Wash at 30 degrees or less",
        ironAtLowTemperature: "Iron at low temperature",
        doNotTumbleDry: "Do not tumble dry",
        doNotIron: "Do not iron",
        doNotSteam: "Do not steam",
        doNotIronOrSteam: "Do not iron or steam",
      };

      return Object.entries(aftercareBooleans)
        .filter(([, value]) => value === true)
        .map(([key]) => labels[key])
        .filter(Boolean);
    },
  },
};
</script>

<style lang="scss" scoped>
.aftercare__list {
  list-style-position: outside;
  list-style-type: disc;
  margin: 12px 0 0;
  padding: 0 0 0 1.125em;

  li {
    margin: 0;
    padding: 0;
    @include editorial-body(14px);
    color: inherit;
    line-height: 1.35;
  }
}

.wysiwyg p {
  @include editorial-body(20px);
}
</style>
